export const API_EXTERNAL_ENDPOINT = 'search/cottages'

export const API_INTERNAL_ENDPOINT = 'rurality/v3/search/cottages'
